import { getOverviewCategories } from './getOverviewCategories';
import { getOverview } from './getOverview';

export const categoryService = {
  getOverviewCategories,
  getOverview,
};
